<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Editar área</h5>
        </div>        
        <emt-form ref="area-form" v-bind:resource="config.api + '/area/'" v-bind:items="itemsForm" v-bind:updateData="update"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form'

export default{
    name: 'emt-form-edit-area',
    data: function () {
        return {
            itemsForm: [
                {
                    'name': 'name',
                    'label': 'Nombre área',
                    'placeholder': 'Ingrese nombre de área',
                    'value': null,
                    'maxlength': '50',
                    'type': 'text',
                    'errors': []
                }, {
                    'name': 'unit',
                    'label': 'Unidad',
                    'placeholder': 'Seleccione una unidad',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'responsible',
                    'label': 'Responsable',
                    'placeholder': 'Seleccione responsable',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'boss',
                    'label': 'Jefe',
                    'placeholder': 'Seleccione jefe',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': []
                }, {
                    'name': 'is_active',
                    'label': 'Estado',
                    'value': false,
                    'type': 'checkbox',
                    'errors': []
                }
            ],
            config: Config,
            update: true
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getUnits()
    },
    methods: {
        getData: function (url) {
            url = url + this.$route.params.id + '/'
            let self = this
            self.$http.get(url).then(function (response) {
                self.setValue(response.body)
            }, function (response) {
            })
        },
        setValue: function (value) {
            let self = this
            for (var form in self.itemsForm) {
                if (self.itemsForm[form].name === 'unit' || self.itemsForm[form].name === 'responsible' || self.itemsForm[form].name === 'boss') {
                    var activeOptions = self.itemsForm[form].select_options
                    var flag = false
                    for (var i = 0; i < activeOptions.length; i++) {
                        if (activeOptions[i].value === value[self.itemsForm[form].name]) {
                            self.itemsForm[form].value = value[self.itemsForm[form].name]
                            flag = true
                        }
                    }
                    if (!flag) {
                        self.itemsForm[form].value = ''
                    }
                } else {
                    self.itemsForm[form].value = value[self.itemsForm[form].name]
                }
            }
        },
        /*
        *esta funcion permite consultar y listar las unidades
        */
        getUnits: function () {
            var self = this
            self.$http.get(Config.api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name
                    })
                }
                this.getResponsible()
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los usuarios del aplicativo
        */
        getResponsible: function () {
            var self = this
            self.$http.get(Config.api + '/user/?nopaginate=1&is_active=true&ordering=name&groups=3').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[2].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    })
                }
                this.getBoss()
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        /*
        *esta funcion permite consultar y listar los usuarios del aplicativo
        */
        getBoss: function () {
            var self = this
            self.$http.get(Config.api + '/user/?nopaginate=1&is_active=true&ordering=name&groups=3').then(function (response) {
                for (var data in response.body) {
                    self.itemsForm[3].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].username
                    })
                }
                this.getData(Config.api + '/area/')
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        }
    },
    components: {
        'emt-form': EmtForm
    }
}
</script>



// WEBPACK FOOTER //
// emt-form-edit-area.vue?cb40d646